var exports = {
  "k": "xaee3c4fa--523cf7--container",
  "T": "xaee3c4fa--523cf7--groups",
};

module.exports = exports;
